export enum PostFileType {
  Video = 0,
  Image = 1,
  PixelStreamArcaneMirage = 2,
  PixelStreamInternal = 3,
  PixelStreamAWS = 4,
  Panorama = 5,
  PanoramaVideo = 6,
  Zip = 7,
  Cesium = 8,
  Pdf = 9,
  CesiumDynamic = 10,
}

export const PostFileTypeMetadata: {
  [key in PostFileType]: { description: string; iconClass: string };
} = {
  [PostFileType.Video]: { description: 'Video', iconClass: 'bi bi-film' },
  [PostFileType.Image]: { description: 'Image', iconClass: 'bi bi-file-image' },
  [PostFileType.PixelStreamArcaneMirage]: { description: 'Pixel Stream', iconClass: 'bi bi-camera-reels' },
  [PostFileType.PixelStreamInternal]: { description: 'Pixel Stream', iconClass: 'bi bi-camera-reels' },
  [PostFileType.PixelStreamAWS]: { description: 'Pixel Stream', iconClass: 'bi bi-camera-reels' },
  [PostFileType.Panorama]: { description: 'Panoramic Image', iconClass: 'bi bi-image' },
  [PostFileType.PanoramaVideo]: { description: 'Panoramic Video', iconClass: 'bi bi-film' },
  [PostFileType.Zip]: { description: 'Zip File', iconClass: 'fa fa-file-archive-o' },
  [PostFileType.Cesium]: { description: 'Interactive', iconClass: 'bi bi-globe-asia-australia' },
  [PostFileType.Pdf]: { description: 'Pdf File', iconClass: 'bi bi-file-pdf' },
  [PostFileType.CesiumDynamic]: { description: 'Interactive (Dynamic)', iconClass: 'bi bi-globe-asia-australia' },
};
